"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiEmployeeDiscounts {
    static getList(token) {
        let url = `/employeediscounts/list`;
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiEmployeeDiscounts;
